interface Props {
  status: string
}

const STATUS_COLOR: Record<string, { bg: string; text: string; label: string }> = {
  online:  { bg: '#e8f5e9', text: '#2e7d32', label: 'Online' },
  offline: { bg: '#ffebee', text: '#c62828', label: 'Offline' },
  warning: { bg: '#fff8e1', text: '#f57f17', label: 'Warning' },
}

export default function NodeStatusBadge({ status }: Props) {
  const style = STATUS_COLOR[status] ?? { bg: '#f0f0f0', text: '#666', label: status }
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 10px',
        borderRadius: 12,
        fontSize: 12,
        fontWeight: 600,
        background: style.bg,
        color: style.text,
        whiteSpace: 'nowrap',
      }}
    >
      {style.label}
    </span>
  )
}
